import { Box, FormControlLabel, Switch, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
import ChartHelpTooltip from '../common/ChartHelpTooltip';
import { useFormContext } from '../../contexts/FormContext';

const SwitchField = ({ field }: { field: any }) => {
  const { formData, getFormDataItem, handleChange } = useFormContext();

  const label = (
    <>
      <Box component="span" sx={{ display: 'inline-flex' }}>
        <Typography color={'text.primary'}>{field.label}</Typography>
      </Box>
      {field.hasOwnProperty('help') && (
        <Box component="span" sx={{ display: 'inline-flex' }}>
          <ChartHelpTooltip chartType={field.help} />
        </Box>
      )}
    </>
  );

  return (
    <Grid size={12} key={field.label}>
      <Box sx={{ display: 'inline' }}>
        <FormControlLabel
          control={
            <Switch
              checked={Boolean(getFormDataItem(formData, field.name))}
              onChange={(e) =>
                handleChange({ target: { name: field.name, value: e.target.value, type: e.target.type, checked: e.target.checked } }, field)
              }
            />
          }
          label={label}
        />
      </Box>
    </Grid>
  );
};

export default SwitchField;
